// XSM-1563: Account settings page - wire profile and password sections
// Author: Abhishek Bharti
// Date: 30/07/2026
import { FormikProvider } from 'formik';
import PageContainer from '@/sections/container';
import { MainContainer } from '@/apps/core';
import { useAccountSettings } from '@/hooks/account.settings.hooks';
import { UserSelfAccount, UserPasswordManagement } from '@/apps/account-settings';

const AccountSettings = () => {
  const {
    accountSettingFormik,
    profileEditMode,
    setProfileEditMode,
    passwordValue,
    setPasswordValue,
    values,
    setShowPassMngt,
    showPassMngt,
    loggedUser,
    errors,
    valid,
    handleSubmit,
    handleResetPassword,
    handleOpenPasswordManagement,
    handleClosePasswordManagement,
    resetLinkSend
  } = useAccountSettings();

  return (
    <PageContainer>
      <MainContainer headerTitle="Users Information">
        <FormikProvider value={accountSettingFormik}>
          <UserSelfAccount
            {...{
              profileEditMode,
              setProfileEditMode,
              showPassMngt,
              loggedUser,
              values,
              errors,
              valid,
              handleSubmit,
              accountSettingFormik
            }}
          />
          <UserPasswordManagement {...{
            profileEditMode,
            passwordValue,
            setPasswordValue,
            values,
            setShowPassMngt,
            showPassMngt,
            loggedUser,
            errors,
            accountSettingFormik,
            handleResetPassword,
            handleOpenPasswordManagement,
            handleClosePasswordManagement,
            resetLinkSend
          }} />
        </FormikProvider>
      </MainContainer>
    </PageContainer>
  );
};

export default AccountSettings;
